export default __webpack_public_path__ + "static/media/204.f8d220e0.png";